export interface FirestoreToObjInput<T> {
  snapshot: { exists: boolean | (() => boolean); data: () => Record<string, any> | undefined; id: string };
  Deserializer: { deserialize: (data: Record<string, any>) => T };
}

export const firestoreToObj = <T>({ snapshot, Deserializer }: FirestoreToObjInput<T>): T | undefined => {
  const exists = typeof snapshot.exists === 'function' ? snapshot.exists() : snapshot.exists;

  if (!exists) {
    return undefined;
  }

  const data = { ...(snapshot.data() ?? {}), id: snapshot.id };
  return Deserializer.deserialize(data) as unknown as T;
};
